import { useTranslation } from 'react-i18next';
import { SETUP_DEVICES, type SetupDevice } from '../../hooks/useSetup.ts';
import { toggleDevice } from '../../lib/setup.ts';

const ICONS: Record<SetupDevice, string> = {
  garmin: '⌚',
  zwift: '\u{1F3AE}',
  apple_watch: '⌚',
  android_watch: '⌚',
  bike_computer: '\u{1F6B2}',
  phone: '\u{1F4F1}',
};

/** "What do you ride with?" multi-select cards (both watch kinds on the web). */
export function DevicePicker({
  value,
  onChange,
}: Readonly<{ value: readonly SetupDevice[]; onChange: (devices: SetupDevice[]) => void }>) {
  const { t } = useTranslation();
  return (
    <fieldset className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      <legend className="sr-only">{t('setup.devices.title')}</legend>
      {SETUP_DEVICES.map((device) => {
        const pressed = value.includes(device);
        return (
          <button
            key={device}
            type="button"
            aria-pressed={pressed}
            onClick={() => onChange(toggleDevice(value, device))}
            className={`flex items-center gap-3 rounded-xl border px-4 py-3 text-left text-sm font-medium transition-colors ${
              pressed
                ? 'border-(--color-accent) bg-(--color-accent)/15 text-(--color-text-primary)'
                : 'border-(--color-border) bg-(--color-bg-tertiary) text-(--color-text-secondary) hover:border-gray-400'
            }`}
          >
            <span aria-hidden="true" className="text-xl">{ICONS[device]}</span>
            <span className="flex-1">{t(`setup.devices.options.${device}`)}</span>
            {pressed && <span aria-hidden="true" className="text-(--color-accent)">✓</span>}
          </button>
        );
      })}
    </fieldset>
  );
}
